import EventDispatcher from './EventDispatcher';
import Global from './Global';

export default class Header {
  constructor() {}

  init() {
    this.scoreTotal = 0;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'time_tick':
        this.onTick(data.message.data.time);
        break;
      case 'update_score':
        this.updateScore(data.message.data.score);
        break;
      case 'save_score':
        this.saveScore();
        break;
      case 'reset_room':
        this.resetScore();
        break;
    }
  }

  onTick(time) {
    document.querySelector('.game_timer_sec .label').innerHTML = time;
    document.querySelector(
      '.game_timer_sec .progress'
    ).style.transform = `translate(-${100 - (time / 30) * 100}%, -50%)`;
    if (time <= 0) {
      this.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'level_complete',
          data: {},
        },
      });
    }
  }

  updateScore(score) {
    this.scoreTotal += score;
    document.querySelector(
      '#score_sec .label'
    ).innerHTML = `SCORE: ${this.scoreTotal}`;
  }

  saveScore() {
    Global.scoreTotal = this.scoreTotal;
  }

  resetScore() {
    this.scoreTotal = 0;
    document.querySelector(
      '#score_sec .label'
    ).innerHTML = `SCORE: ${this.scoreTotal}`;
  }
}
